import { Nullable } from "@/general/custom-types/CustomTypes";

export class FacilityFormModel {
  id?: Nullable<number>;
  active?: Nullable<boolean>;
  storeNumber?: Nullable<string>;
  phone?: Nullable<string>;
  totalArea?: Nullable<number>;
  shopArea?: Nullable<number>;
  area?: Nullable<string>;
  street?: Nullable<string>;
  mall?: Nullable<string>;
  city?: Nullable<string>;
  postcode?: Nullable<string>;
  province?: Nullable<string>;
  country?: Nullable<string>;
  timezone?: Nullable<string>;
  customer?: Nullable<number>;

  constructor(
    id?: Nullable<number>,
    active?: Nullable<boolean>,
    storeNumber?: Nullable<string>,
    phone?: Nullable<string>,
    totalArea?: Nullable<number>,
    shopArea?: Nullable<number>,
    area?: Nullable<string>,
    street?: Nullable<string>,
    mall?: Nullable<string>,
    city?: Nullable<string>,
    postcode?: Nullable<string>,
    province?: Nullable<string>,
    country?: Nullable<string>,
    timezone?: Nullable<string>,
    customer?: Nullable<number>
  ) {
    this.id = id;
    this.active = active;
    this.storeNumber = storeNumber;
    this.phone = phone;
    this.totalArea = totalArea;
    this.shopArea = shopArea;
    this.area = area;
    this.street = street;
    this.mall = mall;
    this.city = city;
    this.postcode = postcode;
    this.province = province;
    this.country = country;
    this.timezone = timezone;
    this.customer = customer;
  }
}
